import { Component, Input, OnInit, Optional } from '@angular/core';
import { Router } from '@angular/router';

import { IonNav, ModalController } from '@ionic/angular';

import * as dayjs from 'dayjs';
import * as customParseFormat from 'dayjs/plugin/customParseFormat';
import * as isSameOrBefore from 'dayjs/plugin/isSameOrBefore';

import { AssetInformationModalPage } from '../asset-information-modal.page';

import { ApiService } from '@services/api.service';
import { ConfigService } from '@services/config.service';

import { IAssetInformation } from '@models/types';

dayjs.extend(customParseFormat);
dayjs.extend(isSameOrBefore);

@Component({
    selector: 'app-asset-information-content-modal',
    templateUrl: './asset-information-content-modal.page.html',
    styleUrls: ['./asset-information-content-modal.page.scss'],
})
export class AssetInformationContentModalPage implements OnInit {
    @Input() public state: Partial<IAssetInformation> = { isQuestion: false };

    public canGoBack = false;
    public dayjs = dayjs;

    public assetAlreadyInList = false;

    constructor(
        public apiService: ApiService,
        public configService: ConfigService,
        private modalController: ModalController,
        @Optional() private nav: IonNav,
        private router: Router,
    ) { }

    ngOnInit() {
        this.router.getCurrentNavigation()?.extras?.state ? this.state = this.router.getCurrentNavigation().extras.state as Partial<IAssetInformation> : null;
        if (this.state.selectedAssets && this.state.selectedAssets?.length > 0) {
            if (this.state.asset) {
                if (this.state.selectedAssets.includes(this.state.asset.identifiers.asset_identifier)) {
                    this.assetAlreadyInList = true;
                }
            }
        }
    }

    ionViewWillEnter() {
        if (this.canGoBack && this.nav) {
            this.nav.swipeGesture = false;
        }
    }

    public async openViewAssetModal(assetId: string) {
        try {
            const asset = await this.apiService.getAsset(assetId);
            const state: Partial<IAssetInformation> = {
                assetId,
                asset,
                multi: false,
                type: 'view',
                pageType: 'modal'
            }
            const assetInformationModal = await this.modalController.create({
                component: AssetInformationModalPage,
                componentProps: {
                    state
                },
                canDismiss: true
            });
            await assetInformationModal.present();
        } catch (error) {
            console.log('AssetInformationContentModalPage openViewAssetModal() error=', error);
        }
    }

    public async closeModal() {
        await this.modalController.dismiss();
    }

    public async openUri(url: string) {
        window.location.href = url;
    }

}
